import { themeV5 } from 'theme/v5'

export const lineGraphFormatter = (state, { payload }) => {
  console.log('[lineGraphFormatter] payload:', payload.points)

  if (!Array.isArray(payload.points) || payload.points.length === 0) {
    return state
  }

  const { totals = {} } = payload

  const normalizeValue = (value) => {
    if (value === 0) {
      return null
    }
    return value ?? null
  }

  // ---- Sort by month ----
  const sorted = [...payload.points].sort(
    (a, b) => new Date(a.month) - new Date(b.month)
  )

  // ---- Labels (month only, no year) ----
  const labels = sorted.map((x) => {
    const parts = x.monthLabel.split(' ')
    return parts[0]
  })

  // ---- Data values ----
  const overfillData = sorted.map((x) => normalizeValue(x.overfill))
  const wrongFuelTypeData = sorted.map((x) => normalizeValue(x.wrongFuelType))
  const multiFillsData = sorted.map((x) => normalizeValue(x.multiFills))

  // ---- Colors ----
  const OVERFILL_COLOR = themeV5.palette.accent.teal
  const WRONG_FUEL_COLOR = themeV5.palette.accent.blue
  const MULTIFILL_COLOR = themeV5.palette.accent.sky

  // ---- Build dataset labels WITH total counts ----
  const labelOverfill = `Overfill (${totals.overfill ?? 0})`
  const labelWrongFuel = `Wrong Fuel Type (${totals.wrongFuelType ?? 0})`
  const labelMultiFills = `Multi-Fills (${totals.multiFills ?? 0})`
  // odometer intentionally ignored

  return {
    ...state,
    data: {
      labels,
      values: wrongFuelTypeData, // required for redux (KEEP)
      datasets: [
        {
          label: labelOverfill,
          data: overfillData,
          color: OVERFILL_COLOR,
          legendBaseLabel: 'Overfill',
          totalCount: totals.overfill ?? 0,
          borderWidth: 2,
          tension: 0.3,
        },
        {
          label: labelWrongFuel,
          data: wrongFuelTypeData,
          color: WRONG_FUEL_COLOR,
          legendBaseLabel: 'Wrong Fuel Type',
          totalCount: totals.wrongFuelType ?? 0,
          borderWidth: 2,
          tension: 0.3,
        },
        {
          label: labelMultiFills,
          data: multiFillsData,
          color: MULTIFILL_COLOR,
          legendBaseLabel: 'Multi-Fills',
          totalCount: totals.multiFills ?? 0,
          borderWidth: 2,
          tension: 0.3,
        },
      ],
      totalOdometers: totals.odometer ?? 0,
    },
  }
}
